import { Request } from '@/classes/Request'

/**
 * Fetch an Authorize.Net hosted-form add-profile token for the invited family,
 * token-authenticated. Shape matches the standalone token-fetcher so it can be
 * passed straight to AuthorizeNetFormDialog's :token-fetcher.
 * GET /api/enrollment/invitation/{token}/funding-sources/authorize-iframe
 */
export const enrollmentAuthorizeIframe = async (
  token: string
): Promise<{ token: string; isSandbox: boolean }> => {
  const response = await new Request().get(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/funding-sources/authorize-iframe`
  )
  return {
    token: response.data.token,
    isSandbox: response.data.is_sandbox
  }
}
